import { Map } from 'immutable';

import Api from '../api';

import Budget from './model';
import { addMultipleAction, addAction, updateAction, removeAction } from './actions';

export default class BudgetsApi {
  static fetchAll() {
    return Api.get('api/budgets').map((budgets) =>
      addMultipleAction(Map(budgets.map((budget) => [budget.id, new Budget(budget)])))
    );
  }

  static fetch(id) {
    return Api.get(`api/budgets/${id}`).map((budget) => addAction(new Budget(budget)));
  }

  static create(data) {
    return Api.post('api/budgets', data).map((budget) => addAction(new Budget(budget)));
  }

  static update(id, data) {
    return Api.patch(`api/budgets/${id}`, data).map((budget) => updateAction(new Budget(budget)));
  }

  static delete(id) {
    return Api.delete(`api/budgets/${id}`).map(() => removeAction(id));
  }
}
